import { createSelector } from "reselect";

import getDomain from "../base_getters/get_domain";

const getGroups = createSelector([
  getDomain
], (domain) => domain.groups);

export default getGroups;
